import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { Button, Card, Col, Container, Dropdown, DropdownButton, Row} from "react-bootstrap";
import { axiosAuth_PLATFORM_API } from '../utils/AxoisUtilComponent';
import { useTranslation } from 'react-i18next';
import classes from './AdminPages.module.css';
import { translateAPIError } from '../utils/apiUtils';


const ServiceAdminNewView = (props) => {

  // Utilities
  const { t } = useTranslation(['common', 'custom']);
  const navigate = useNavigate();

  // Initialize with actual JSON obj.  If not, will get error.
  const [serviceAttrs, setServiceAttrs] = useState({
    code: '',
    name: '',
    description: '',
    type: '',
    pingEndpoint: '',
    pollInterval: 1,
    status: 'MAINT_OFF',
  });

  const typeOptions = [
    { key: "INTERNAL_SRV", value: "INTERNAL_SRV" },
    { key: "EXTERNAL_SRV", value: "EXTERNAL_SRV" }
  ];


  // UI Functions

  const [errMsg, setErrMsg] = useState('');

  const onAttrsInputChange = (e) => {
    setServiceAttrs({ ...serviceAttrs, [e.target.name]: e.target.value })
  }

  const onTypeSelect = (key, event) => {
    setServiceAttrs({ ...serviceAttrs, type: key });
  }

  const handleSubmit = (e) => {
    e.preventDefault();

    // Validate code and name
    if (!serviceAttrs.code || serviceAttrs.code.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_code"));
    } else if (serviceAttrs.code.length > 30) {
      setErrMsg(t("I18N_ERR_Max_len_code") + 30);
    } else if (!serviceAttrs.name || serviceAttrs.name.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_name"));
    } else if (serviceAttrs.name.length > 30) {
      setErrMsg(t("I18N_ERR_Max_len_name") + 30);
    } else {
      validateUniqueCodeAndName();
    }

    return;
  }

  // Since this is async, need to call this first, and check for duplicate
  function validateUniqueCodeAndName() {

    new Promise(async (resolve, reject) => {
      try {
        // Check for duplication of code
        const res = await axiosAuth_PLATFORM_API.get("services?code=" + serviceAttrs.code);

        resolve(res.data);

        if ((res.status === 200) && res.data.length > 0) {
          setErrMsg(t("I18N_ERR_Dup_code"));
          return;
        } else {
          // Check for duplication of name
          const res2 = await axiosAuth_PLATFORM_API.get("services?name=" + serviceAttrs.name);

          resolve(res2.data);

          if ((res2.status === 200) && res2.data.length > 0) {
            // Service id is already defined
            setErrMsg(t("I18N_ERR_Dup_name"));
            return;
          } else {
            validateOtherFields();
            return;
          }
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
          validateOtherFields();
        }
        return;
      }
    });
  }

  function validateOtherFields() {
    // Validate form inputs

    if (!serviceAttrs.description || serviceAttrs.description.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_description"));
    } else if (!serviceAttrs.type || serviceAttrs.type.length === 0) {
      setErrMsg(t("I18N_ERR_Need_type"));
    } else if (serviceAttrs.description.length > 200) {
      setErrMsg(t("I18N_ERR_Max_len_desc") + 200);
    } else if (serviceAttrs.type.length > 30) {
      setErrMsg(t("I18N_ERR_Max_len_type") + 30);
    } else if (serviceAttrs.pingEndpoint && serviceAttrs.pingEndpoint.length > 500) {
      setErrMsg(t("I18N_ERR_Max_len_ping_endpt") + 500);
    } else if (   (serviceAttrs.pollInterval != null)
               && (serviceAttrs.pollInterval.toString().trim().length !== 0)
               && (!Number.isInteger(Number(serviceAttrs.pollInterval.toString().trim())))) {
      setErrMsg(t("I18N_Poll_interval") + t("I18N_ERR_must_be_int"));
    } else {
      createNewService();
    }
  }

  const createNewService = () => {

    // Make a deep copy
    const reqBody = JSON.parse(JSON.stringify(serviceAttrs));

    if ((reqBody.pingEndpoint != null) && (reqBody.pingEndpoint.trim().length === 0)) {
      reqBody.pingEndpoint = null;
    }

    if ((reqBody.pollInterval != null) && (reqBody.pollInterval.toString().trim().length === 0)) {
      reqBody.pollInterval = null;
    }

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_PLATFORM_API.post("services", reqBody);

        resolve(res.data);

        if (res.status === 201) {

          // Return to list
          navigate(-1);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });
  }


  const handleCancel = (e) => {
    e.preventDefault();

    // Return to list
    navigate(-1);
  }


  return (
    <>
      <Card style={{overflow:'auto', border:'0', boxShadow:'0 2px 2px 0px rgba(0,0,0,0.1)',
                    padding:'20px 40px 20px 40px', maxWidth:'2500px', width:'100%', fontSize:'13px'}}>

        <div style={{display:'flex'}}>
        <span className={classes.admin_pages__page_title}>
          {t("I18N_New_Service")}
        </span>
        </div>

        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px'}}>
          <div display='flex'>
            <span>
              {t("I18N_Service_Info")}
            </span>
          </div>
          <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>
        </div>

        <Container>
          <form>
            <Row className={classes.admin_pages__field_label}>
              <Col md={3}>{t("I18N_Code")}: *</Col>
              <Col md={3}>{t("I18N_Name")}: *</Col>
              <Col md={3}>{t("I18N_Description")}: *</Col>
              <Col md={3}>{t("I18N_Type")}: *</Col>
            </Row>
            <Row className={classes.admin_pages__field_value}>
              <Col md={3}>
                <input className={classes.admin_pages__field_editable} style={{width:'100%'}} name="code" value={serviceAttrs.code}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col md={3}>
                <input className={classes.admin_pages__field_editable} style={{width:'100%'}} name="name" value={serviceAttrs.name}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col md={3}>
                <textarea className={classes.admin_pages__field_editable} style={{width:'100%'}} name="description" value={serviceAttrs.description}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col md={3}>
                <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                  title={!serviceAttrs.type ? t("common:I18N_DROPDOWN_PROMPT") :
                          t("I18N_" + (typeOptions.find( ({ key }) => key === serviceAttrs.type )).value)}
                  onSelect={onTypeSelect}> 
                  {typeOptions.map((item, index) => {
                    return (
                      <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                        {t("I18N_" + item.value)}
                      </Dropdown.Item>
                    );
                  })}
                </DropdownButton>
              </Col>
            </Row>

            <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
              <Col md={3}>{t("I18N_Ping_endpoint")}:</Col>
              <Col md={3}>{t("I18N_Poll_interval") + " (" + t("I18N_minutes") + ")"}:</Col>
              <Col md={3}></Col>
              <Col md={3}></Col>
            </Row>
            <Row className={classes.admin_pages__field_value}>
              <Col md={3}>
                <textarea className={classes.admin_pages__field_editable} style={{width:'100%'}} name="pingEndpoint" value={serviceAttrs.pingEndpoint}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col md={3}>
                <input className={classes.admin_pages__field_editable} style={{width:'100%'}} name="pollInterval" value={serviceAttrs.pollInterval}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col md={3}></Col>
              <Col md={3}></Col>
            </Row>

            <hr className="solid" style={{ marginTop: '30px' }}></hr>

            <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px', fontStyle: 'italic' }}>
              <span>{t("I18N_Req_fields")}</span>
            </Row>

            <Row>
              <div display='flex' style={{ marginTop: '15px' }}>
                <Button size="sm" variant="outline-secondary" className="mb-3"
                  style={{ float: 'left' }}
                  onClick={handleCancel}>
                  {t("I18N_Cancel")}
                </Button>
                <Button size="sm" variant="outline-secondary" className="mb-3"
                  style={{ marginLeft: '15px' }}
                  onClick={handleSubmit}>
                  {t("I18N_Submit")}
                </Button>
                <span className={classes.admin_pages__field_label} style={{ marginLeft: '30px', color: 'rgba(200,0,0)', verticalAlign: 'top' }}>
                  {errMsg}
                </span>
              </div>
            </Row>
          </form>
        </Container>

      </Card>
    </>
  );
}

export default ServiceAdminNewView;
